import { Component } from '@angular/core';
import { SpinnerService } from '../../services/spinner.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AsyncPipe, NgIf } from '@angular/common';

@Component({
  selector: 'app-spinner-service',
  standalone: true,
  imports: [ProgressSpinnerModule, AsyncPipe, NgIf],
  templateUrl: './spinner-service.component.html',
  styleUrl: './spinner-service.component.scss'
})
export class SpinnerServiceComponent {
  constructor(public spinnerService: SpinnerService) {}
}
